import * as S from './styled'

const FromPrice = ({ isBlackWeekend, price, unit }) => {
  const hasPrice = Boolean(price?.integers)

  if (!hasPrice) {
    return null
  }

  return (
    <S.FromPrice isBlackWeekend={isBlackWeekend} as="div" size="kilo" decoration="strike">
      R$ {price.integers},{price.decimals} /{unit}
    </S.FromPrice>
  )
}

export default FromPrice
